module.exports = __webpack_public_path__ + "img/Flag_of_the_People's_Republic_of_China.214508bc.svg";